module.exports = __webpack_public_path__ + "static/media/all-stories.e1d8f544.png";